import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageToolbar.css';
import { Button } from 'primereact/button';
import Flag from 'react-flagkit';
import { Tooltip } from 'primereact/tooltip';


const LanguageToolbar = (props) => {
  const { i18n } = useTranslation();
  const current = i18n.language.split('-')[0]; 

  const handleClick = (code) => {
    i18n.changeLanguage(code);
    props.handleLanguageChange(code);
  };

  return (
    <div className="LanguageToolbar">
      <Tooltip target=".lang-btn" position="bottom" className="CustomTooltip" />

    
         <Button
        label=""
        icon={<Flag country="BR" size={24} style={{ borderRadius: '10px' }} />}
        className={`lang-btn ${current === 'pt' ? 'active p-button-rounded' : 'p-button-rounded p-button-outlined'}`}
        onClick={() => handleClick('pt')}
        data-pr-tooltip="Português (Brasil)"
      />

      <Button
        label=""
        icon={<Flag country="US" size={24} style={{ borderRadius: '10px' }} />}
        className={`lang-btn ${current === 'en' ? 'active p-button-rounded' : 'p-button-rounded p-button-outlined'}`}
        onClick={() => handleClick('en')}
        data-pr-tooltip="English (USA)"
      />

      <Button
        label=""
        icon={<Flag country="ES" size={24} style={{ borderRadius: '10px' }} />}
        className={`lang-btn ${current === 'es' ? 'active p-button-rounded' : 'p-button-rounded p-button-outlined'}`}
        onClick={() => handleClick('es')}
        data-pr-tooltip="Español (España)"
      />
     
    </div>
  );
};

export default LanguageToolbar;
